export enum PaymentMethodStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  ComingSoon = 'COMING_SOON',
}
